{
  "id": "amethyst",
  "name": "Amethyst",
  "description": "Violet theme — amethyst purples with a magenta glow",
  "colors": {
    "light": {
      "primary": "#7c3aed",
      "secondary": "#e9ddff",
      "positive": "#16a34a",
      "negative": "#e11d48",
      "warning": "#d97706",
      "important": "#c026d3",
      "light": "#f6f2fe",
      "dark": "#140a24",
      "surface": "#ece5f8",
      "darksurface": "#1e1330",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#a78bfa",
      "secondary": "#3b2c5a",
      "positive": "#4ade80",
      "negative": "#fb7185",
      "warning": "#fbbf24",
      "important": "#e879f9",
      "light": "#e7ddf7",
      "dark": "#140a24",
      "surface": "#e7ddf7",
      "darksurface": "#1e1330",
      "white": "#ffffff"
    }
  }
}
